import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ContactInfoRoutingModule } from './contact-info-routing.module';
import { ContactInfoComponent } from './contact-info.component';
import { MaterialModule } from '../shared/material/material.module';
import { IwgcommonModule } from '../iwgcommon/iwgcommon.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule } from '@angular/forms';
import { SharedPipesModule } from '../shared/pipes/sharedpipes.module';
import { AppRoutingModule } from '../app-routing.module';


@NgModule({
  declarations: [ ContactInfoComponent,],
  imports: [
    CommonModule,
    MaterialModule,
    IwgcommonModule,
    FlexLayoutModule,
    AppRoutingModule,
    FormsModule,
    SharedPipesModule,
    ContactInfoRoutingModule
  ],
  exports: [ContactInfoComponent]
})
export class ContactInfoModule { }
